import { Link } from "@inertiajs/react";
import type { InertiaLinkProps } from "@inertiajs/react";
import type { ReactNode } from 'react';

interface NavLinkProps extends Omit<InertiaLinkProps, 'children'> {
    active?: boolean;
    className?: string;
    children?: ReactNode | ((props: { active: boolean; isActive: boolean }) => ReactNode);
}

export default function NavLink({
    active = false,
    className = "",
    children,
    ...props
}: NavLinkProps) {
    return (
        <Link {...props} className={className}>
            {typeof children === "function" ? children({ active, isActive: active }) : children}
        </Link>
    );
}
